var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkLinkicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3333 4.6665L8.66668 4.6665V5.99984H11.3333C12.4333 5.99984 13.3333 6.89984 13.3333 7.99984C13.3333 9.09984 12.4333 9.99984 11.3333 9.99984H8.66668V11.3332H11.3333C13.1733 11.3332 14.6667 9.83984 14.6667 7.99984C14.6667 6.15984 13.1733 4.6665 11.3333 4.6665ZM7.33334 9.99984H4.66668C3.56668 9.99984 2.66668 9.09984 2.66668 7.99984C2.66668 6.89984 3.56668 5.99984 4.66668 5.99984H7.33334V4.6665H4.66668C2.82668 4.6665 1.33334 6.15984 1.33334 7.99984C1.33334 9.83984 2.82668 11.3332 4.66668 11.3332H7.33334V9.99984ZM5.33334 7.33317H10.6667V8.6665H5.33334V7.33317Z",
    fill: "#6C757D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkLinkicon);
export default __webpack_public_path__ + "static/media/sk-linkicon.d45905505510e12f435660178c269068.svg";
export { ForwardRef as ReactComponent };